import { render, staticRenderFns } from "./bstlgz.vue?vue&type=template&id=f431657c&scoped=true"
import script from "./bstlgz.vue?vue&type=script&lang=js"
export * from "./bstlgz.vue?vue&type=script&lang=js"
import style0 from "./bstlgz.vue?vue&type=style&index=0&id=f431657c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f431657c",
  null
  
)

export default component.exports